<!--
 * @Descripttion: 注册页面组件
 * @Author: congz
 * @Date: 2020-06-11 10:01:19
 * @LastEditors: congz
 * @LastEditTime: 2020-08-18 19:58:16
--> 

<template>
  <div class="register">
    <div>
      <el-card class="box-card" shadow="hover">
        <div slot="header" class="clearfix">
          <span>Register</span>
        </div>
        <div class="item">
          <el-form :model="form" status-icon :rules="rules" ref="form">
            <el-form-item prop="phone">
              <el-input v-model="form.phone" placeholder="Phone Number"></el-input>
            </el-form-item>
            <el-form-item prop="captcha_value">
              <el-input
                v-model="form.captcha_value"
                placeholder="Math Captcha Answer"
                style="width:62%;float:left"
              ></el-input>
              <span
                class="math-captcha"
                @click="refreshCaptcha"
              >{{captchaExpression}}</span>
            </el-form-item>
            <el-form-item prop="code">
              <el-input
                v-model="form.code"
                placeholder="Verification Code"
                style="width:62%;float:left"
              ></el-input>
              <el-button
                type="primary"
                style="width:36%;float:right"
                @click="sendCode"
                :disabled="counting"
              >{{codeText}}</el-button>
            </el-form-item>
          </el-form>
          <div style="margin-top:15px">
            <a href="javascript:;" class="btn-gradient desert block" @click="register('form')">Register</a>
          </div>
          <el-link type="primary" href="/#/login" style="float:right;margin-bottom:20px;">Already have an account? Log in directly></el-link>
        </div>
      </el-card>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import * as userAPI from '@/api/users'
export default {
  name: 'Register',
  data() {
    var validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter phone number'))
      } else if (value.length !== 10) {
        callback(new Error('Phone number must be 10 digits'))
      }
      callback()
    }
    var validateCode = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('Please enter verification code'))
      } else if (value.length !== 6) {
        callback(new Error('Verification code must be 6 digits'))
      }
      callback()
    }
    return {
      imageUrl: '',
      form: {
        phone: '',
        captcha_value: '',
        code: ''
      },
      captchaId: '',
      captchaExpression: '',
      rules: {
        phone: [{ validator: validatePhone, trigger: 'blur' }],
        code: [{ validator: validateCode, trigger: 'blur' }]
      },
      counting: false,
      codeText: 'Get Code',
      totalTime: 60
    }
  },
  methods: {
    ...mapActions(['setUser']),
    refreshCaptcha() {
      userAPI.getMathCaptcha().then(res => {
        if (res.status === 200) {
          this.captchaId = res.data.captcha_id
          this.captchaExpression = res.data.expression
        }
      })
    },
    sendCode() {
      var phone = this.form.phone
      if (phone === '') {
        this.notifyError('Please enter phone number', null)
        return
      }
      if (this.form.captcha_value === '') {
        this.notifyError('Please enter math captcha answer', null)
        return
      }
      if (this.counting) {
        return
      }
      userAPI
        .sendSMSCode({
          phone: phone,
          captcha_id: this.captchaId,
          captcha_value: this.form.captcha_value
        })
        .then(res => {
          if (res.status === 200) {
            // 发送成功后才启动倒计时
            this.counting = true
            this.codeText = this.totalTime + 's'
            var clock = window.setInterval(() => {
              this.totalTime--
              this.codeText = this.totalTime + 's'
              if (this.totalTime < 0) {
                window.clearInterval(clock)
                this.codeText = 'Get Code'
                this.totalTime = 60
                this.counting = false
              }
            }, 1000)
            // 算式一次性使用,清空并刷新
            this.form.captcha_value = ''
            this.refreshCaptcha()
            this.notifySucceed('Verification code sent')
          } else {
            this.refreshCaptcha()
            this.notifyError('Failed to send code', res.msg)
          }
        })
        .catch(error => {
          this.refreshCaptcha()
          this.notifyError('Failed to send code', error)
        })
    },
    register(formName) {
      this.$refs[formName].validate(valid => {
        if (!valid) {
          return
        }
        userAPI
          .smsLogin(this.form)
          .then(res => {
            if (res.status === 404) {
              this.notifyError('Verification failed', res.msg)
            } else if (res.status === 200) {
              // 注册即登录,保存登录态
              let user = JSON.stringify(res.data.user)
              localStorage.setItem('user', user)
              localStorage.setItem('token', res.data.token)
              // 登录信息存到vuex,同步header登录状态
              this.setUser(res.data.user)
              this.notifySucceed('Registered successfully')
              this.$router.push({
                name: 'Home'
              })
            } else {
              this.notifyError('Registration failed', res.msg)
            }
          })
          .catch(error => {
            this.notifyError('Registration failed', error)
          })
      })
    }
  },
  mounted() {
    this.refreshCaptcha()
  },
  components: {}
}
</script>

<style scoped>
@import '../assets/css/button.css';
.text {
  font-size: 14px;
}

.item {
  margin: 0 auto;
  width: 300px;
}

.clearfix {
  font-size: 20px;
}

.box-card {
  margin: 0 auto;
  text-align: center;
  width: 400px;
  margin-top: 100px;
  margin-bottom: 200px;
  border-radius: 10px;
}
/*算式验证码*/
.math-captcha {
  width: 36%;
  float: right;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: #f5f7fa;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  cursor: pointer;
  color: #6b7a6e;
  font-weight: bold;
  user-select: none;
}
.math-captcha:hover {
  color: #409eff;
  border-color: #c6e2ff;
  background: #ecf5ff;
}
</style>
